import React, { useState } from 'react';
import { submitToFormspree } from '../utils/formspree';

function Survey() {
  const [formData, setFormData] = useState({
    hairLossStage: '',
    previousTreatments: [],
    mainConcern: '',
    desiredOutcome: '',
    timeframe: '',
    email: '',
    phone: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      previousTreatments: checked
        ? [...prev.previousTreatments, value]
        : prev.previousTreatments.filter(item => item !== value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await submitToFormspree({
        formType: 'Hair Solution Survey',
        subject: `Survey submission from ${formData.email}`,
        fields: {
          hairLossStage: formData.hairLossStage,
          previousTreatments: formData.previousTreatments,
          mainConcern: formData.mainConcern,
          desiredOutcome: formData.desiredOutcome,
          timeframe: formData.timeframe,
          email: formData.email,
          phone: formData.phone,
        },
      });

      setIsSubmitted(true);
    } catch (error) {
      setError(error.message);
      console.error('Error submitting survey:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="mx-auto max-w-2xl py-10 text-center">
        <h3 className="font-display text-3xl font-semibold text-primary-700">Thank you</h3>
        <p className="mt-3 text-ink-muted">
          We received your responses and will follow up with guidance tailored to your goals.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl">
      {error && (
        <div className="mb-6 rounded-lg bg-red-50 p-4 text-red-600">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6 border border-primary-100 bg-white p-6 sm:p-8">
        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            How would you describe your hair loss stage?
          </label>
          <select
            name="hairLossStage"
            value={formData.hairLossStage}
            onChange={handleChange}
            className="w-full rounded-lg border p-3 focus:ring-2 focus:ring-primary-500"
            required
          >
            <option value="">Select an option</option>
            <option value="early">Early stages - slight thinning</option>
            <option value="moderate">Moderate - noticeable thinning</option>
            <option value="advanced">Advanced - significant hair loss</option>
            <option value="complete">Complete hair loss in some areas</option>
          </select>
        </div>

        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            Have you tried any of the following? (Select all that apply)
          </label>
          <div className="space-y-2">
            {['Custom hair systems', 'Clip-in hair pieces', 'Wigs', 'Maintenance services'].map((option) => (
              <label key={option} className="flex items-center text-ink-soft">
                <input
                  type="checkbox"
                  value={option}
                  checked={formData.previousTreatments.includes(option)}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            What is your main concern?
          </label>
          <select
            name="mainConcern"
            value={formData.mainConcern}
            onChange={handleChange}
            className="w-full rounded-lg border p-3 focus:ring-2 focus:ring-primary-500"
            required
          >
            <option value="">Select an option</option>
            <option value="appearance">Overall appearance</option>
            <option value="confidence">Self-confidence</option>
            <option value="professional">Professional image</option>
            <option value="dating">Dating life</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            When would you like to start?
          </label>
          <select
            name="timeframe"
            value={formData.timeframe}
            onChange={handleChange}
            className="w-full rounded-lg border p-3 focus:ring-2 focus:ring-primary-500"
            required
          >
            <option value="">Select an option</option>
            <option value="immediate">As soon as possible</option>
            <option value="1month">Within 1 month</option>
            <option value="3months">Within 3 months</option>
            <option value="exploring">Just exploring options</option>
          </select>
        </div>

        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            Email Address
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full rounded-lg border p-3 focus:ring-2 focus:ring-primary-500"
            required
            placeholder="your@email.com"
          />
        </div>

        <div>
          <label className="mb-2 block font-semibold text-ink-soft">
            Phone Number (Optional)
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full rounded-lg border p-3 focus:ring-2 focus:ring-primary-500"
            placeholder="Your phone number"
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className={`w-full rounded-full bg-primary-600 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700 ${
            isLoading ? 'cursor-not-allowed opacity-75' : ''
          }`}
        >
          {isLoading ? 'Submitting...' : 'Send My Details'}
        </button>
      </form>
    </div>
  );
}

export default Survey;
